(function() {
    angular.module('emarket.commons').filter('suffle', function() {
        return function(array, length) {
            var copy = angular.copy(array);
            var sample = [];
            while (sample.length < length) {
                var randomIndex = Math.floor(Math.random() * copy.length);
                sample.push(copy[randomIndex]);
            }
            return sample;
        };
    });
}());
